module.exports = __webpack_public_path__ + "videos/whatsnew-scribble_en.e3c5f31.mp4";